import { render, staticRenderFns } from "./DialogCancelAccount.vue?vue&type=template&id=22b9cd00"
import script from "./DialogCancelAccount.vue?vue&type=script&lang=js"
export * from "./DialogCancelAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22b9cd00')) {
      api.createRecord('22b9cd00', component.options)
    } else {
      api.reload('22b9cd00', component.options)
    }
    module.hot.accept("./DialogCancelAccount.vue?vue&type=template&id=22b9cd00", function () {
      api.rerender('22b9cd00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Home/AccountSettings/MyProfile/Dialogs/DialogCancelAccount.vue"
export default component.exports